var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isTags
        ? [
            _c("Tooltip", { attrs: { placement: "left", transfer: "" } }, [
              _c(
                "div",
                { staticClass: "tag" },
                [
                  _c("div", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm._f("getFirstTag")(_vm.tag)))
                  ]),
                  _vm._v(" "),
                  _c("Icon", { attrs: { type: "ios-eye" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.$util.listTag(_vm.tag)) }
                })
              ])
            ])
          ]
        : [_c("div", [_vm._v("\n      " + _vm._s(_vm.tag) + "\n    ")])]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3580a578", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3580a578","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tagList.vue
// module id = null
// module chunks = 